import { ElementRef, ViewChild, Directive, OnInit } from '@angular/core';
import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';
import { DialogDirective } from 'src/shared-app-portal/components/dialog/dialog.directive';
import { downloadPdf } from 'src/app/shared/utils/download-file';
import { InvoicesDataSource } from 'src/shared-app-portal/components/profile-payments/invoices-datasource';
import {
  getInvoiceStatusIcon,
  InvoiceModel,
  InvoiceStatus
} from 'src/shared-app-portal/components/profile-payments/invoice-model';
import { PaymentService } from 'src/shared-app-portal/services/payment.service';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';

@Directive()
export abstract class BasePaymentsDirective implements OnInit {
  @ViewChild('sendInvoiceModal') sendInvoiceModal: ElementRef;
  @ViewChild('sendInvoiceTemplate', { static: true }) sendInvoiceTemplate: DialogDirective;

  readonly dataSource: InvoicesDataSource;
  invoiceStatus = InvoiceStatus;
  searchText: string = '';
  filterItems: ItemPickerModel[] = [new ItemPickerModel(null, null, 'All Payments')];
  selectedFilterValue: ItemPickerModel = this.filterItems[0];
  invoice: InvoiceModel;
  getInvoiceStatusIcon = getInvoiceStatusIcon;

  constructor(
    protected paymentService: PaymentService,
    protected snackBarService: SnackBarService
  ) {
    this.dataSource = new InvoicesDataSource(paymentService);
  }

  async ngOnInit() {
    this.buildStatusFilters();
    await this.dataSource.loadPayments();
  }

  protected buildStatusFilters() {
    this.filterItems = [new ItemPickerModel(null, null, 'All Payments')];
    this.selectedFilterValue = this.filterItems[0];
    Object.values(InvoiceStatus).forEach((status) => {
      this.filterItems.push(new ItemPickerModel(status, null, status));
    });
  }

  search(event: string) {
    this.searchText = event;
    this.dataSource.search(event.trim());
  }

  itemPickerSelected(item: ItemPickerModel) {
    this.selectedFilterValue = item;
    this.dataSource.filterByInvoiceStatus(item.id);
  }

  async openInvoicePayment(invoice: InvoiceModel) {
    this.invoice = await this.paymentService.getPaymentConfirmation(
      invoice.invoiceType,
      invoice.id
    );
    this.sendInvoiceTemplate.open({
      header: `Order Number ${this.invoice.orderNumber}`
    });
  }

  copyInvoiceLink() {
    this.snackBarService.open('Invoice link copied to your clipboard!', true);
  }

  exportToPDF = async () => {
    await downloadPdf(this.sendInvoiceModal.nativeElement, {
      fileName: 'invoice',
      title: `Invoice #${this.invoice.orderNumber}`
    });
    return true;
  };
}
